import React from 'react';
import styled from 'styled-components';
import Anchor from '../../../components/Anchor';
import { DocsPageAnchorType } from '../types/DocsPageAnchorType';
const DocsPageContentAnchor = ({ text, to, newWindow = true, download, size = DocsPageAnchorType.REGULAR, }) => {
    return React.createElement(DocsPageContentAnchorWrapper, { text: text, href: to, download: download, target: newWindow ? '_blank' : '', rel: newWindow ? 'noopener noreferrer' : '', size: size });
};
export default DocsPageContentAnchor;
const DocsPageContentAnchorWrapper = styled(Anchor) `
  font-size: inherit;
  font-size: ${props => props.size === DocsPageAnchorType.SMALL && '12px'};
  font-size: ${props => props.size === DocsPageAnchorType.REGULAR && '16px'};
  font-size: ${props => props.size === DocsPageAnchorType.LARGE && '18px'};

`;
//# sourceMappingURL=DocsPageContentAnchor.js.map